import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtCarHotlistDialogComponent } from './rt-car-hotlist-dialog/rt-car-hotlist-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { BourqueCoreModule } from '@bds/core';

@NgModule({
    declarations: [RtCarHotlistDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BourqueCoreModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
    ],
    exports: [RtCarHotlistDialogComponent],
})
export class RtCarHotlistModule {}
